import { Vue, Component, Emit, Prop, Watch } from 'vue-property-decorator';
import Modal from '@/assets/common/Modal/Modal.vue'
import Thumbnail from '@/components/Thumbnail/Thumbnail.vue';
import List from '@/assets/common/List/List.vue';
import { WorkerList, WorkerImage, UnitPrice } from "@/types";
import UnitPrices from '@/components/UnitPrices/UnitPrices.vue'

interface Params {
    name?: string;
    role?: string;
    mail?: string;
    memo?: string;
    unit?: any;
}

export type Item = {
    id: string;
    name: string;
    isActive: boolean;
}

@Component({
    components: {
        Modal,
        Thumbnail,
        List,
        UnitPrices
    }
})
export default class WorkerModal extends Vue {

    @Prop()
    isShowWorkerModal!: boolean

    private unitPrice: any | null = null
    private workers: WorkerList[] = []
    private workerId = ''
    private workerName = ''
    private workerLoginId = ''
    private workerRole = ''
    private workerMail = ''
    private workerMemo = ''
    private workerUnitPrices: UnitPrice[] = []
    private workerImage: WorkerImage = {
        id: '',
        url: '',
        file: null
    }
    private hasNotWorkerName = false
    private isMailFormat = true
    private isAdmin = false
    private isContractAdmin = false
    private isMyself = false
    private userId = ''
    private isLoading = false
    private baseUrl = '/workers'
    private clientBaseUrl = '/master/workers'
    private unitPricesTitle = '作業者'
    private isDeleteImage = false
    private accountManagerUrl = process.env.VUE_APP_ACCOUNT_MANAGER_URL
    private changePasswordUrl = `${process.env.VUE_APP_ACCOUNT_MANAGER_URL}/accounts/security`
    private list: any | null = null
    private selectedItem = "";
    private isSpinnerLoading = false
    private searchText = ''
    private headerTitle = '作業者情報'
    private alteredWorkers = false;

    private getWorkers() {
        // 作業者リストを取得する
        this.list = null
        this.isLoading = true
        this.isSpinnerLoading = true
        this.$apiClient.doRequest('get', this.baseUrl).then((ret) => {
            this.workers = ret.workers
            this.list = this.workers;
            if (this.selectedItem) {
                this.isActive(this.selectedItem);
            }
        })
            .finally(() => {
                this.isLoading = false
                this.isSpinnerLoading = false
            })
    }

    private isActive(id: string) {
        this.list?.forEach((item: any) => {
            item.isActive = false;
        });
        this.list?.forEach((item: any) => {
            if (item.id === id) {
                item.isActive = true;
            }
        });
        this.workers?.forEach((item: any) => {
            item.isActive = item.id === id;
        });
    }

    @Watch('isShowWorkerModal')
    onShowWorkerModalChanged() {
        if (this.isShowWorkerModal) {
            this.$apiClient.getUserProfile().then((ret) => {
                if (ret.role && ret.role.indexOf('ADMIN') != -1) {
                    this.isAdmin = true
                }
                this.userId = ret.id
            })
            this.getWorkers()
        }
    }

    @Watch('isShowWorkerModal')
    onModalVisibilityChanged(val: boolean) {
        this.$emit('update-inert', val)
    }

    openSideBar = () => {
         const isResponsive = window.matchMedia('(max-width: 1000px)').matches;
        if (!isResponsive) {
            return; 
        }
        if (document.body.classList.contains('newsSide')) {
            document.body.classList.remove('newsSide')
        } else {
            document.body.classList.add('newsSide')
        }
    }

    closeModal() {
        if (this.alteredWorkers && !window.confirm("変更内容を破棄します。よろしいですか？")) {
            return;
        }
        this.$emit('update:isShowWorkerModal', false);
        this.selectedItem = "";
        this.searchText = '';
        this.workerId = "";
        this.alteredWorkers = false
    }

    private setWorker(workerId: string) {
        this.inputChangedcheck();
        if (this.alteredWorkers == false) {
            this.workerImage = {
                id: '',
                url: '',
                file: null
            }
            this.unitPrice = null
            this.isMailFormat = true
            this.hasNotWorkerName = false
            this.isDeleteImage = false
            if (document.body.classList.contains('newsSide')) {
                document.body.classList.remove('newsSide')
            }
            // クリックした作業者の情報を取得してフォームに渡す
            if (this.isAdmin) {
                this.$apiClient.doRequest('get', `/admin${this.baseUrl}/${workerId}`).then((ret) => {
                    this.isMyself = (this.userId == ret.id)
                    this.workerId = ret.id
                    this.workerLoginId = ret.login_id
                    this.workerName = ret.name
                    this.workerRole = ret.role.indexOf('ADMIN') != -1 ? 'ADMIN' : 'USER'
                    this.workerMail = ret.mail
                    this.workerMemo = ret.memo
                    this.workerUnitPrices = ret.unit
                    this.unitPrice = UnitPrices
                    if (ret.image_id) {
                        this.$apiClient.doRequest('get', `${this.baseUrl}/${workerId}/image`).then(ret => {
                            this.workerImage = ret
                        })
                    }
                })
            } else {
                this.$apiClient.doRequest('get', `${this.baseUrl}/${workerId}`).then((ret) => {
                    this.isMyself = (this.userId == ret.id)
                    this.workerId = ret.id
                    this.workerName = ret.name
                    if (this.isMyself) {
                        this.workerLoginId = ret.login_id
                        this.workerRole = ret.role.indexOf('ADMIN') != -1 ? 'ADMIN' : 'USER'
                        this.workerMail = ret.mail
                    }
                })
            }
            this.selectedItem = workerId;
            this.isActive(workerId);
        }
    }

    setItem(id: string){
        if (id === this.selectedItem) {
            return;
        }
        this.setWorker(id);
    }

    @Watch('searchText')
    private doSearch() {
        const keyword = this.searchText?.trim() ?? '';

        if (!keyword) {
            this.workers = this.list;
            return;
        }
        this.workers = this.list?.filter((item: Item) => item.name.indexOf(this.searchText) > -1)
    }

    @Emit('inputChanged')
    private inputChanged() {
        if (this.alteredWorkers == false) {
            this.alteredWorkers = true;
        }
    }

    private onFileChange(e: any) {
        const files = e.target.files || e.dataTransfer.files;

        if (this.$apiClient.isSizeOver(files)) {
            return
        }

        if (this.$apiClient.isImageFile(files[0].name)) {
            this.workerImage.file = files[0]

            this.$apiClient.getBase64(files[0]).then((image: any) => {
                this.workerImage.url = image.base64 as string
            }).catch(() => {
                window.alert('画像ファイルが読み込めませんでした')
            });
        } else {
            window.alert('画像ファイルを選択してください')
        }
        this.inputChanged()
    }

    private clearImage() {
        this.workerImage.url = ''
        this.workerImage.file = null
        this.isDeleteImage = true
        this.inputChanged()
    }

    private syncWorkerImage() {
        let request = Promise.resolve()

        if (this.isDeleteImage && this.workerImage.id) {
            request = request.then(() => this.$apiClient.doRequest('delete', `/admin${this.baseUrl}/${this.workerId}/image`))
        }

        if (this.workerImage.url && this.workerImage.file) {
            request = request.then(() => this.$apiClient.fileUpload(`/admin${this.baseUrl}/${this.workerId}/image`, this.workerImage.file))
        }

        return request
    }

    inputChangedcheck() {
        if (this.alteredWorkers == true) {
            const confirm = window.confirm('変更内容を破棄します。よろしいですか？')
            if (confirm) {
                this.alteredWorkers = false
            }
        }
    }

    private cancelEdit() {
        if (this.alteredWorkers) {
            const result = window.confirm('変更内容を破棄します。よろしいですか。');
            if (!result) {
                return false;
            }
        }
        this.alteredWorkers = false;
        this.setWorker(this.workerId)
    }

    private async submit() {
        let errmsg: string[] = []
          this.workerMail = this.workerMail?.trim() || ''
          this.workerName = this.workerName?.trim() || ''
        if (!this.workerName) {
            errmsg.push('作業者名を入力してください')
        }
        if (this.workerName.length > 255) {
            errmsg.push(`作業者名は255文字以内で入力してください（現在は${this.workerName.length}文字）`)
        }
        if (this.workerMail && this.workerMail.length > 255) {
            errmsg.push(`メールアドレスは255文字以内で入力してください（現在は${this.workerMail.length}文字）`)
        }
        if (this.workerMail && !this.validateMail(this.workerMail)) {
            errmsg.push('メールアドレスの形式で入力してください')
        }
        if (this.workerMemo && this.workerMemo.length > 21844) {
            errmsg.push(`メモは21844文字以内で入力してください（現在は${this.workerMemo.length}文字）`)
        }
        const refs: any = this.$refs
        let unitPrices
        if (refs.unitPrices) {
            unitPrices = refs.unitPrices.getUnitPrices()
            // 戻ってきた型がstring[]だったらエラーメッセージの配列
            if (unitPrices.length > 0 && typeof unitPrices[0] === 'string') {
                errmsg = errmsg.concat(unitPrices)
            }
        }

        if (errmsg.length > 0) {
            window.alert(errmsg.join('\n'))
            this.isLoading = false
            return false
        }

        this.isLoading = true
        const result = window.confirm("内容を上書きして保存します。よろしいですか。")
        if (!result) {
            this.isLoading = false
            return false;
        }
        let params: Params = {}
        let savePromise: Promise<any> = Promise.resolve()
        if (this.isAdmin) {
            params = {
                name: this.workerName,
                role: this.workerRole,
                mail: this.workerMail,
                memo: this.workerMemo?.trim(),
                unit: unitPrices
            }
            savePromise = this.$apiClient.doRequest('put', `/admin${this.baseUrl}/${this.workerId}`, params)
                .then(async () => {
                    try {
                        return await this.syncWorkerImage();
                    } catch {
                        this.$toasted.error('写真の保存に失敗しました。');
                        return false;
                    }
                })
        } else {
            params = {
                mail: this.workerMail
            }
            if (this.isMyself) {
                savePromise = this.$apiClient.doRequest('put', `${this.baseUrl}/me`, params)
            } else {
                this.$toasted.error('編集する権限がありません。')
                this.isLoading = false
                return
            }
        }
        savePromise.then((result) => {
            if (result === false) {
                return
            }
            this.workers = this.workers.map((worker: WorkerList) => {
                if (worker.id == this.workerId) {
                    worker.name = params.name ? params.name : worker.name
                }
                return worker
            })
            if (this.isAdmin || this.isMyself) {
                this.alteredWorkers = false;
                this.$toasted.success('変更を保存しました。')
                this.setWorker(this.workerId)
            }
        })
            .catch(() => {
                this.$toasted.error('変更に失敗しました。')
            })
            .finally(() => {
                this.isLoading = false
            })
    }

    private validateMail(mail: string) {
        const mailRegx = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
        return mailRegx.test(mail)
    }
}
